export default __webpack_public_path__ + "static/media/lumix-2020-g100v-galleryimages-6-210129.9e19a5e8.jpg";